import {getAppDetails} from "../../services/appService";

export const loader = async ({ params }) => {
    return await getAppDetails(params.appId);
}
